import {
  Checkbox,
  FormControl,
  FormLabel,
  HStack,
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  Text,
  Tooltip,
} from "@chakra-ui/react";
import { useCallback } from "react";
import { Settings } from "../Workbench";

interface RecordingSettingsProps {
  settings: Settings;
  setSettings: (settings: Settings) => void;
}

const RecordingSettings = ({
  settings,
  setSettings,
}: RecordingSettingsProps) => {
  const saveSettings = useCallback((updatedSettings: Settings) => {
    localStorage.setItem("settings", JSON.stringify(updatedSettings));
  }, []);

  const handleChangeCountdown = useCallback(
    (_: string, valueAsNumber: number) => {
      if (Number.isNaN(valueAsNumber)) {
        return;
      }
      const updatedSettings: Settings = {
        ...settings,
        countdown: valueAsNumber,
      };
      setSettings(updatedSettings);
      saveSettings(updatedSettings);
    },
    [settings, setSettings, saveSettings]
  );

  return (
    <HStack
      border="1px solid"
      borderRadius="lg"
      borderColor="gray.400"
      py={2}
      px={5}
      spacing={5}
    >
      <Tooltip
        label="Automatically moves to the next student and starts recording."
        hasArrow={true}
      >
        <FormControl>
          <Checkbox
            isChecked={settings.recordingMode === "auto"}
            onChange={(e) => {
              const updatedSettings: Settings = {
                ...settings,
                recordingMode: e.target.checked ? "auto" : "default",
              };
              setSettings(updatedSettings);
              saveSettings(updatedSettings);
            }}
          >
            <Text>Automated recording mode</Text>
          </Checkbox>
        </FormControl>
      </Tooltip>
      <FormControl>
        <Checkbox
          isChecked={settings.recordingOrder === "random"}
          onChange={(e) => {
            const updatedSettings: Settings = {
              ...settings,
              recordingOrder: e.target.checked ? "random" : "default",
            };
            setSettings(updatedSettings);
            saveSettings(updatedSettings);
          }}
        >
          <Text>Random phrase</Text>
        </Checkbox>
      </FormControl>
      <FormControl display="flex" alignItems="center">
        <FormLabel fontWeight="normal" mb={0}>
          Countdown
        </FormLabel>
        <NumberInput
          step={1}
          min={0}
          value={settings.countdown}
          onChange={handleChangeCountdown}
        >
          <NumberInputField />
          <NumberInputStepper>
            <NumberIncrementStepper />
            <NumberDecrementStepper />
          </NumberInputStepper>
        </NumberInput>
      </FormControl>
    </HStack>
  );
};

export default RecordingSettings;
